(function () {
  'use strict';

  const PROD_API = 'https://living-crystals.vercel.app/api';
  const LOCAL_API = 'http://localhost:5000/api';

  function apiBase() {
    const configured = window.LC_PUBLIC_API || (window.LC_REVIEWS && window.LC_REVIEWS.apiBase);
    const host = window.location.hostname;
    const isLocal = host === '127.0.0.1' || host === 'localhost';
    if (isLocal) return LOCAL_API;
    if (configured && !String(configured).includes('localhost')) return configured;
    return PROD_API;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function formatDate(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch {
      return '';
    }
  }

  function setMeta(post) {
    if (!post) return;
    const title = post.seoTitle || post.title;
    const desc = post.seoDescription || post.excerpt || '';
    if (title) document.title = `${title} — Living Crystals`;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (desc) metaDesc.setAttribute('content', desc.slice(0, 160));
  }

  function postUrl(base, slug) {
    const root = base || '/pages/blog-post';
    const sep = root.indexOf('?') >= 0 ? '&' : '?';
    return `${root}${sep}slug=${encodeURIComponent(slug)}`;
  }

  function postSlug(post) {
    const raw = post.slug || post.id || '';
    if (raw === 'null' || raw === 'undefined') return post.id || '';
    return raw;
  }

  /** Featured image from API only (field: featuredImage). No body/SEO fallbacks. */
  function featuredImageUrl(post) {
    return post?.featuredImage?.url || '';
  }

  function logFeaturedImage(post, context) {
    const fi = post?.featuredImage;
    console.log('[lc-cf-blog] featured image', context, {
      entryId: post?.id,
      assetId: fi?.assetId || null,
      url: fi?.url || null,
    });
  }

  function journalCoverDataUrl(title) {
    const label = String(title || 'Living Crystals Journal').slice(0, 72);
    const svg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 500" role="img">' +
      '<defs><linearGradient id="lc-journal-g" x1="0%" y1="0%" x2="100%" y2="100%">' +
      '<stop offset="0%" stop-color="#10312b"/><stop offset="100%" stop-color="#2a1629"/>' +
      '</linearGradient></defs>' +
      '<rect width="800" height="500" fill="url(#lc-journal-g)"/>' +
      '<circle cx="400" cy="188" r="56" fill="none" stroke="#b8976a" stroke-width="2" opacity="0.85"/>' +
      '<path d="M400 132v112M344 188h112" stroke="#b8976a" stroke-width="1.5" opacity="0.55"/>' +
      '<text x="400" y="300" text-anchor="middle" fill="#f3e9d8" font-family="Georgia,serif" font-size="26">' +
      label.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') +
      '</text></svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }

  function renderCard(post, articleBase) {
    logFeaturedImage(post, 'listing-card');
    const href = postUrl(articleBase, postSlug(post));
    const photoUrl = featuredImageUrl(post);
    const cardImg = photoUrl || journalCoverDataUrl(post.title);
    const img =
      '<img src="' +
      escapeHtml(cardImg) +
      '" alt="' +
      escapeHtml(post.featuredImage?.alt || post.title) +
      '" loading="lazy" width="800" height="500" class="' +
      (photoUrl ? 'lc-cf-blog__card-img--photo' : 'lc-cf-blog__card-img--cover') +
      '">';
    const category = post.category ? `<span>${escapeHtml(post.category)}</span>` : '';
    const date = post.publishedDate ? `<span>${escapeHtml(formatDate(post.publishedDate))}</span>` : '';
    const author = post.author ? `<span>${escapeHtml(post.author)}</span>` : '';

    return (
      '<article class="lc-cf-blog__card">' +
      `<a href="${escapeHtml(href)}" class="lc-cf-blog__card-media">${img}</a>` +
      '<div class="lc-cf-blog__card-body">' +
      `<div class="lc-cf-blog__meta">${category}${date}${author}</div>` +
      `<h2 class="lc-cf-blog__card-title"><a href="${escapeHtml(href)}">${escapeHtml(post.title)}</a></h2>` +
      (post.excerpt ? `<p class="lc-cf-blog__excerpt">${escapeHtml(post.excerpt)}</p>` : '') +
      `<a href="${escapeHtml(href)}" class="lc-cf-blog__read">Read article</a>` +
      '</div></article>'
    );
  }

  async function fetchJson(url) {
    const res = await fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    const data = await res.json().catch(function () {
      return {};
    });
    return { res, data };
  }

  async function initList(root) {
    if (!root || root.dataset.lcCfInit === 'true') return;
    root.dataset.lcCfInit = 'true';

    const grid = root.querySelector('[data-lc-cf-grid]');
    const status = root.querySelector('[data-lc-cf-status]');
    const pager = root.querySelector('[data-lc-cf-pager]');
    const prevBtn = root.querySelector('[data-lc-cf-prev]');
    const nextBtn = root.querySelector('[data-lc-cf-next]');
    const articleBase = root.getAttribute('data-article-base') || '/pages/blog-post';
    const pageSize = Number(root.getAttribute('data-page-size')) || 9;

    let skip = 0;
    let total = 0;

    async function load() {
      if (status) {
        status.textContent = 'Loading stories…';
        status.classList.remove('lc-cf-blog__status--error');
      }
      if (grid) grid.innerHTML = '';

      try {
        const { res, data } = await fetchJson(
          `${apiBase()}/contentful/blog-posts?limit=${pageSize}&skip=${skip}`
        );
        if (!res.ok || !data.ok) {
          throw new Error(data.error || 'Could not load blog posts.');
        }

        total = data.total || 0;
        const items = data.items || [];

        if (!items.length) {
          if (status) status.textContent = 'No articles published yet. Check back soon.';
          if (pager) pager.hidden = true;
          return;
        }

        if (status) status.textContent = '';
        if (grid) grid.innerHTML = items.map(function (p) { return renderCard(p, articleBase); }).join('');

        if (pager && prevBtn && nextBtn) {
          pager.hidden = total <= pageSize;
          prevBtn.disabled = skip <= 0;
          nextBtn.disabled = skip + pageSize >= total;
        }
      } catch (err) {
        if (status) {
          status.textContent = err.message || 'Could not load blog posts.';
          status.classList.add('lc-cf-blog__status--error');
        }
        if (pager) pager.hidden = true;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        skip = Math.max(0, skip - pageSize);
        load();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        skip = skip + pageSize;
        load();
      });
    }

    load();
  }

  async function fetchPostBySlug(slug) {
    const { res, data } = await fetchJson(
      `${apiBase()}/contentful/blog-posts/${encodeURIComponent(slug)}`
    );
    if (res.ok && data.ok && data.post) {
      return data.post;
    }

    const list = await fetchJson(`${apiBase()}/contentful/blog-posts?limit=100`);
    if (!list.res.ok || !list.data.ok) {
      throw new Error(data.error || list.data.error || 'Article not found.');
    }

    const items = list.data.items || [];
    const match = items.find(function (p) {
      const key = postSlug(p);
      return p.id === slug || p.slug === slug || key === slug;
    });
    if (!match) {
      throw new Error(data.error || 'Post not found');
    }
    return match;
  }

  function renderArticle(root, post, status) {
    logFeaturedImage(post, 'article-page');
    setMeta(post);

    const titleEl = root.querySelector('[data-lc-cf-article-title]');
    const metaEl = root.querySelector('[data-lc-cf-article-meta]');
    const featuredEl = root.querySelector('[data-lc-cf-article-featured]');
    const contentEl = root.querySelector('[data-lc-cf-article-content]');
    const tagsEl = root.querySelector('[data-lc-cf-article-tags]');
    const body = root.querySelector('[data-lc-cf-article-body]');

    if (titleEl) titleEl.textContent = post.title;
    if (metaEl) {
      const parts = [];
      if (post.category) parts.push(post.category);
      if (post.publishedDate) parts.push(formatDate(post.publishedDate));
      if (post.author) parts.push(post.author);
      metaEl.textContent = parts.join(' · ');
    }
    if (featuredEl) {
      const photoUrl = featuredImageUrl(post);
      if (photoUrl) {
        featuredEl.innerHTML =
          `<img src="${escapeHtml(photoUrl)}" alt="${escapeHtml(post.featuredImage?.alt || post.title)}" loading="eager" width="1200">`;
        featuredEl.hidden = false;
      } else {
        featuredEl.innerHTML =
          `<img src="${escapeHtml(journalCoverDataUrl(post.title))}" alt="" loading="eager" width="1200" class="lc-cf-blog__card-img--cover">`;
        featuredEl.hidden = false;
      }
    }
    if (contentEl) contentEl.innerHTML = post.contentHtml || '';
    if (tagsEl) {
      if (post.tags?.length) {
        tagsEl.innerHTML = post.tags.map(function (t) {
          return `<span class="lc-cf-article__tag">${escapeHtml(t)}</span>`;
        }).join('');
        tagsEl.hidden = false;
      } else {
        tagsEl.hidden = true;
      }
    }
    if (body) body.hidden = false;
    if (status) status.textContent = '';
  }

  async function initArticle(root) {
    if (!root || root.dataset.lcCfInit === 'true') return;
    root.dataset.lcCfInit = 'true';

    const status = root.querySelector('[data-lc-cf-status]');
    const params = new URLSearchParams(window.location.search);
    let slug = params.get('slug') || params.get('id');
    if (slug === 'null' || slug === 'undefined') slug = '';

    if (!slug) {
      if (status) {
        status.textContent = 'Missing article. Choose a story from the journal.';
        status.classList.add('lc-cf-blog__status--error');
      }
      return;
    }

    if (status) status.textContent = 'Loading…';

    try {
      const post = await fetchPostBySlug(slug);
      renderArticle(root, post, status);
    } catch (err) {
      if (status) {
        status.textContent = err.message || 'Could not load article.';
        status.classList.add('lc-cf-blog__status--error');
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-lc-cf-blog-list]').forEach(initList);
    document.querySelectorAll('[data-lc-cf-blog-article]').forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
